import './components/accordion';
import './components/responsive-background-image';
import './components/carousel';

(function () {
    const body = document.body;

    /**
     * Remove preload class
     */
    window.addEventListener('load', function () {
        body.classList.remove('preload');
    });


    /**
     * Navigation toggle
     */
    document.getElementById('btn-nav-toggle').addEventListener('click', function () {
        this.classList.toggle('is-active');
        const hasNavOpen = body.classList.contains('has-nav-open');

        body.classList.toggle('has-nav-open', !hasNavOpen);
        body.classList.toggle('has-nav-closed', hasNavOpen);

        if (body.classList.contains('has-nav-open')) {
            this.setAttribute('aria-expanded', 'true');
        } else {
            this.setAttribute('aria-expanded', 'false');
        }
    });


    /**
     * Submenu toggle
     */
    document.querySelectorAll('.submenu-toggle').forEach(function(toggle) {
        toggle.addEventListener('click', function() {
            const parent = this.parentElement;
            if (parent.classList.contains('dropdown-active')) {
                parent.classList.toggle('dropdown-active');
            } else {
                parent.classList.toggle('dropdown-active');
                var siblings = parent.parentElement.children;
                Array.prototype.forEach.call(siblings, function(sibling) {
                    if (sibling !== parent) {
                        sibling.classList.remove('dropdown-active');
                    }
                });
            }
        });
    });


    document.querySelectorAll('nav ul > li.is-dropdown-submenu-parent').forEach(function(item) {
        item.addEventListener('mouseover', function() {
            document.body.classList.remove('dropdown-closed');
            document.body.classList.add('dropdown-open');
        });

        item.addEventListener('mouseleave', function() {
            document.body.classList.remove('dropdown-open');
            document.body.classList.add('dropdown-closed');
        });
    });

    window.addEventListener("scroll", function () {
        const body = document.body;

        // Check if body has the class 'page--homepage'
        if (body.classList.contains("page--homepage")) {
            if (window.scrollY > 50) {
                body.classList.add("scrolled");
            } else {
                body.classList.remove("scrolled");
            }
        }
    });


})();
